/**
 * Shared status pill / badge primitive. Maps to the existing App.css .badge classes.
 *
 * variant: 'success' | 'danger' | 'warning' | 'accent' | 'muted'  (default: 'muted')
 *
 * All other props pass through to the root <span>.
 */
const variantMap = {
  success: 'badge-success',
  danger: 'badge-danger',
  warning: 'badge-warning',
  accent: 'badge-accent',
  muted: 'badge-muted',
};

export default function Badge({ variant = 'muted', className = '', children, ...props }) {
  const classes = ['badge', variantMap[variant] ?? 'badge-muted', className]
    .filter(Boolean)
    .join(' ');

  return (
    <span className={classes} {...props}>
      {children}
    </span>
  );
}
